import React from "react";

const RESPONSE_OPTIONS = [
  { value: "yes",     label: "Yes",     color: "#22c55e" },
  { value: "no",      label: "No",      color: "#ef4444" },
  { value: "partial", label: "Partial", color: "#f59e0b" },
];

/**
 * Single row inside the question table.
 * Props:
 *   item        { q, desc, sub }
 *   answer      { response: "yes"|"no"|"partial"|null, comment: string }
 *   rowKey      unique key for radio group
 *   onResponse  ("yes"|"no"|"partial") => void
 *   onComment   (string) => void
 */
const QuestionRow = ({ item, answer, rowKey, onResponse, onComment }) => (
  <tr
    style={{ borderBottom: "1px solid #f0f0f0" }}
    onMouseEnter={(e) => (e.currentTarget.style.background = "#fafafe")}
    onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
  >
    {/* Question */}
    <td style={{ padding: "13px 12px", maxWidth: "240px", color: "#222", lineHeight: 1.5 }}>
      {item.q}
    </td>

    {/* Description */}
    <td style={{ padding: "13px 12px", maxWidth: "220px", color: "#555", lineHeight: 1.5 }}>
      {item.desc}
    </td>

    {/* Sub dimension */}
    <td style={{ padding: "13px 12px", color: "#555", whiteSpace: "nowrap" }}>
      {item.sub}
    </td>

    {/* Response radios — Yes / No / Partial */}
    <td style={{ padding: "13px 12px", whiteSpace: "nowrap" }}>
      {RESPONSE_OPTIONS.map((opt) => {
        const isSelected = answer.response === opt.value;
        return (
          <label
            key={opt.value}
            style={{
              marginRight: "14px",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "13px",
              color: isSelected ? opt.color : "#555",
              fontWeight: isSelected ? "700" : "400",
            }}
          >
            <label
  style={{
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
  }}
>
  <input
    type="radio"
    name={rowKey}
    checked={isSelected}
    onChange={() => onResponse(opt.value)}
    style={{
      appearance: "none",
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      border: `2px solid ${isSelected ? opt.color : "#888"}`,
      background: "white",
      cursor: "pointer",
      position: "relative",
    }}
  />

 {isSelected && (
  <span
    style={{
      position: "absolute",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      background: opt.color,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      pointerEvents: "none",
    }}
  />
)}
</label>
            {opt.label}
          </label>
        );
      })}
    </td>

    {/* Comment */}
    <td style={{ padding: "13px 12px" }}>
      <textarea
        value={answer.comment}
        onChange={(e) => onComment(e.target.value)}
        placeholder="Add comment..."
        style={{
          width: "180px",
          minHeight: "48px",
          resize: "vertical",
          border: "1px solid #ddd",
          borderRadius: "4px",
          padding: "5px 7px",
          fontSize: "12px",
          outline: "none",
          fontFamily: "inherit",
        }}
      />
    </td>
  </tr>
);

export default QuestionRow;